import { CustomThemeOptions } from '../types';
import { ColorMode } from '../ThemeModeContext';

import logoDark from '../../assets/tenants/carsif/logo.png';
import logoLight from '../../assets/tenants/carsif/logo.png';
import logoMain from '../../assets/tenants/carsif/logo.png';
import authCircleInside from '../../assets/tenants/carsif/InnerCircle.png';
import authCircleOutside from '../../assets/tenants/carsif/ellipse-outside.svg';

export const getCarsifThemeOptions = (mode: ColorMode = 'light'): CustomThemeOptions => {
  const isDark = mode === 'dark';

  return {
    palette: {
      mode,
      primary: isDark
        ? {
            main: '#ff7043',
            light: '#ff8a65',
            dark: '#d84315',
            contrastText: '#ffffff',
          }
        : {
            main: '#B33C12',
            light: '#FF6F43',
            dark: '#8C0800',
            contrastText: '#ffffff',
          },
      secondary: {
        main: isDark ? '#3a3330' : '#2B2B2B',
      },
      background: isDark
        ? {
            default: '#0e0d0c',
            paper: '#201d1c', // Lighter, elevated card/blob surface
          }
        : {
            default: '#f8fafc',
            paper: '#ffffff',
          },
      text: isDark
        ? {
            primary: '#f1f5f9',
            secondary: '#a8a29e',
          }
        : {
            primary: '#1e293b',
            secondary: '#64748b',
          },
      divider: isDark ? 'rgba(255, 255, 255, 0.09)' : 'rgba(0, 0, 0, 0.08)',
      black: {
        main: '#2B2D2E',
        light: '#515151',
        dark: '#202122',
      },
      white: {
        main: '#EFEFEF',
        light: '#F5F5F5',
        dark: '#E8E8E8',
      },
    },
    typography: {
      button: {
        textTransform: 'none',
      },
      fontFamily: ['Mukta', 'Saira'].join(','),
    },
    breakpoints: {
      values: {
        xs: 0,
        sm: 961,
        md: 1200,
        lg: 1200,
        xl: 1536,
      },
    },
    gradients: {
      primary: isDark
        ? 'linear-gradient(90deg, #c43e1c 0%, #ff7043 100%)'
        : 'linear-gradient(90deg, #C43E1C 0%, #2B2B2B 100%)',
      secondary: isDark
        ? 'linear-gradient(180deg, #992c0c 0%, #201d1c 100%)'
        : 'linear-gradient(180deg, #C43E1C 0%, #2B2B2B 100%)',
    },
    media: {
      logos: {
        main: logoMain,
        light: logoLight,
        dark: logoDark,
      },
      authCircleInside,
      authCircleOutside,
    },
    components: {
      MuiPaper: {
        styleOverrides: {
          root: {
            backgroundImage: 'none',
            ...(isDark && {
              border: '1px solid rgba(255, 255, 255, 0.08)',
              boxShadow: '0 4px 20px -2px rgba(0, 0, 0, 0.45)',
            }),
          },
        },
      },
      MuiAppBar: {
        styleOverrides: {
          root: {
            backgroundColor: isDark ? '#201d1c' : '#ffffff',
            color: isDark ? '#f1f5f9' : '#1e293b',
          },
        },
      },
      MuiDrawer: {
        styleOverrides: {
          paper: {
            backgroundColor: isDark ? '#141211' : '#ffffff',
            borderRight: `1px solid ${isDark ? 'rgba(255, 255, 255, 0.08)' : 'rgba(0, 0, 0, 0.08)'}`,
          },
        },
      },
    },
  };
};

export const carsifThemeOptions = getCarsifThemeOptions('light');
